import { Person } from '@fs/zion-person'
import { Separator, Skeleton } from '@fs/zion-ui'
import React from 'react'

export default function OtherRelationshipHeaderSkeleton(): JSX.Element {
  return (
    <>
      <Skeleton.Paragraph maxWidth={200} />
      <Separator size="nano" />
      <Person
        noBoldName
        loading
        personObj={{}}
        componentSize="sm"
        hideLifespan
        hidePid
        avatarSize="smaller"
        openPersonOverlay
      />

      <Separator size="xxs" />

      <Skeleton.Paragraph maxWidth={200} />
      <Separator size="nano" />
      <Person
        noBoldName
        loading
        personObj={{}}
        componentSize="sm"
        hideLifespan
        hidePid
        avatarSize="smaller"
        openPersonOverlay
      />

      <Separator size="xxs" />
    </>
  )
}
